export const FIND_ATM_LOCATION_LINK = 'https://m2.greendot.com/locate';
